<template>
  <div style="display: flex; gap: 10px">
    <div style="display: flex; gap: 10px; flex-direction: column; width: 100%">
      <div style="display: flex; gap: 10px; justify-content: space-around">
        <card-total
          v-for="(item, i) in totalCardData"
          :key="i"
          :icon="item.icon"
          :title="item.title"
          :value="item.value"
          :color="item.color"
        ></card-total>
      </div>
      <div
        style="
          border: 3px dotted #5dbb66;
          margin-top: 50px;
          padding: 50px 30px 30px 30px;
          position: relative;
        "
      >
        <div
          class="m-card"
          style="
            background: #5dbb66;
            color: #fff;
            font-size: 2em;
            font-weight: 600;
            position: absolute;
            top: -30px;
            display: flex;
            flex-direction: row;
          "
        >
          <div>Lobby Building A :</div>
          <div>4/22</div>
          <div></div>
        </div>
        <div
          style="
            display: grid;
            grid-template-columns: auto auto auto;
            gap: 10px;
          "
        >
          <card-worker v-for="(item, i) in worker" :key="i" :item="item" />
        </div>
      </div>
    </div>
    <div style="display: flex; gap: 10px; flex-direction: column; width: 100%">
      <div class="m-card">
        <div style="display: flex">
          <div>Manpower History</div>
          <div></div>
        </div>
        <div>
          <bar-chart
            :chartdata="chartData"
            :options="optionsChart"
            areaColor="#4EA24E"
            height="200"
          />
        </div>
      </div>
      <div
        style="
          border: 3px dotted #5dbb66;
          margin-top: 50px;
          padding: 50px 30px 30px 30px;
          position: relative;
        "
      >
        <div
          class="m-card"
          style="
            background: #5dbb66;
            color: #fff;
            font-size: 2em;
            font-weight: 600;
            position: absolute;
            top: -30px;
            display: flex;
            flex-direction: row;
          "
        >
          <div>Lobby Building B :</div>
          <div>4/22</div>
          <div></div>
        </div>
        <div
          style="
            display: grid;
            grid-template-columns: auto auto auto;
            gap: 10px;
          "
        >
          <card-worker v-for="(item, i) in worker" :key="i" :item="item" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BarChart from "../../../../components/ChartJs/BarChart.vue";
import CardTotal from "./components/CardTotal.vue";
import CardWorker from "./components/CardWorker.vue";

export default {
  components: {
    CardTotal,
    BarChart,
    CardWorker,
  },
  data() {
    return {
      totalCardData: [
        {
          color: "#75D684",
          icon: "supervisor_account",
          title: "Total Visitor Registered",
          value: 12,
        },
        {
          color: "#FFA200",
          icon: "person_add",
          title: "Today Visitor Registered",
          value: 12,
        },
        {
          color: "#D91F95",
          icon: "favorite",
          title: "Visitor In Target Location",
          value: 12,
        },
      ],
      worker: [
        {
          img: require('@/assets/images/card id.png'),
          name: "Somsak",
          status: 1,
          mac: "AC23345E3AC",
          firstdate: "2022-07-11 08:30:33",
          manhour: 5,
        },
        {
          img: require('@/assets/images/card id.png'),
          name: "Somsak",
          status: 1,
          mac: "AC23345E3AC",
          firstdate: "2022-07-11 08:30:33",
          manhour: 5,
        },
        {
          img: require('@/assets/images/card id.png'),
          name: "Somsak",
          status: 1,
          mac: "AC23345E3AC",
          firstdate: "2022-07-11 08:30:33",
          manhour: 5,
        },
        {
          img: require('@/assets/images/card id.png'),
          name: "Somsak",
          status: 1,
          mac: "AC23345E3AC",
          firstdate: "2022-07-11 08:30:33",
          manhour: 5,
        },
      ],
      chartData: {
        datasets: [
          {
            data: [3, 4, 5, 6, 2],
            label: "Temperature ( °C )",
            pointBorderWidth: 1,
            borderWidth: 3,
            borderColor: "#4EA24E",
          },
        ],
        labels: [1, 2, 3, 4, 5],
      },
      optionsChart: {
        maintainAspectRatio: false,
        responsive: true,
        legend: {
          display: false,
          title: {},
          position: "bottom",
        },
        scales: {
          yAxes: [
            {
              // id: "A",
              ticks: {
                // beginAtZero: true,
                // fontColor: "#ffffff",
                // step: 1,
                min: 0,
              },
              // position: "left",
              scaleLabel: {
                display: true,
                // labelString: this.chartdata.tooltip_label,
              },
            },
          ],
          // xAxes: [
          //   {
          //     // ticks: {
          //     //   // beginAtZero: true,
          //     //   fontColor: "#ffffff",
          //     // },
          //     // scaleLabel: {
          //     //   // display: true,
          //     //   // labelString: "Timestamp",
          //     // },
          //     type: 'time',
          //   },
          // ],
        },
      },
    };
  },
  methods: {
    
  },
};
</script>

<style lang="
scss" scoped>
</style>